import React from "react";
import MenuBoard from "./MenuBoard";
import PriceBoard from "./PriceBoard";
import SupportContact from "./SupportContact";

function App() {
  // var isCocaCola = window.location.pathname.includes("coca-cola");

  // return isCocaCola
  //   ? React.createElement(PriceBoard, null)
  //   : React.createElement(MenuBoard, null);

  return <SupportContact />;
}

export default App;
